<template>
    <div>
        <div class="form-canvas-container">
            <el-row :gutter="20" style="display: flex;">
                <el-col :span="16" ref="leftColumn" class="pdf-column limiter">
                    <div
                        class="pdfvuer"
                        :class="[!pageRendered ? 'page-not-loaded-yet' : '']"
                        v-loading="!pageRendered"
                        :element-loading-text="getText('audit_report_pdf_generation_loading_page_message')"
                        element-loading-background="rgba(0, 0, 0, 0.4)"
                    >
                        <canvas ref="canvas" v-show="pageRendered" ></canvas>
                        <template v-show="pageRendered && item.display">
                            <editable-zone
                                v-for="(zone, key) in sortedZones"
                                :key="key"
                                :zone="zone"
                                :page-index="item.index"
                                :field-name="key"
                                :canvas-width="canvasWidth"
                                :roundHighValues="pageUsingHighValuesRounding.includes(item.page)"
                            ></editable-zone>
                        </template>
                    </div>
                </el-col>
                <el-col :span="8" ref="rightColumn" class="pdf-column ">
                    <div>
                        <pdf-descriptor-input
                            v-for="(zone, key) in sortedZones"
                            :key="key"
                            :zone="zone"
                            :name="key"
                            :audit-data="auditData"
                            :user-data="userData"
                            :user-data-already-setted="userDataAlreadySetted"
                            :page-index="item.index"
                            :disabled="!item.display || !pageRendered"
                            :no-pdf-template="noPdfTemplate"
                        ></pdf-descriptor-input>
                        <div v-if="item.text_zones.length === 0" class="no-fields">
                            <h1>{{ getText('audit_report_pdf_generation_no_editable_fields_available') }}</h1>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div class="page-action">
                <div style="position: relative;">
                    <i class="ti-eye"></i>
                    <i v-if="item.display" style="position: absolute;left: 0;" class="ti-close"></i>
                </div>
                <el-button type="text" @click="updatePageDisplay">
                    <template v-if="item.display">{{ getText('audit_report_pdf_generation_hide_page') }}</template>
                    <template v-else>{{ getText('audit_report_pdf_generation_show_page') }}</template>

                </el-button>
            </div>
        </div>
        <div class="page-action add-page">
            <i class="ti-plus"></i>
            <el-button type="text" @click="addPage">{{ getText('audit_report_pdf_generation_add_page') }}</el-button>
        </div>
    </div>
</template>

<script>

import pdfjsLib from 'pdfjs-dist';
import PdfDescriptorInput from './pdfDescriptorInput.vue';
import EditableZone from './editableZone.vue';
import { mapGetters } from 'vuex';
export default {

    components: {
        PdfDescriptorInput,
        EditableZone,
    },

    props: {
        item: {
            type: Object,
            required: true
        },
        userData:{
            type: Array,
            required: true,
        },
        auditData:{
            type: Object,
            required: true,
        },
        userDataAlreadySetted:{
            type: Boolean,
            required: true,
        },
    },

    data () {
        return {
            page: null,
            pageRendered: false,
            numPages: 0,
            pdfdata: undefined,
            errors: [],
            scale: 1,
            canvasWidth: 0,
            pageUsingHighValuesRounding: ['page_02']
        }
    },
    watch: {
        pageRendered: function (val) {
            if(val){
                let relatedUserData = this.userData.find(userData => userData.index == this.item.index)
                if(relatedUserData && !relatedUserData.display){
                    setTimeout(() => {
                        this.disableView();
                    }, 500);
                }
            }
        },
    },
    computed: {
        ...mapGetters([
            'getText'
        ]),
        sortedZones (){
            let zones = [];
            for(let key in this.item.text_zones){
                zones.push({name: key, value: JSON.parse(JSON.stringify(this.item.text_zones[key]))});
            }
            zones.sort((a,b) => {
                return a.value.y - b.value.y;
            }).sort((a,b) => {
                return a.value.x - b.value.x;
            });
            let ordereZones = {};
            for(let z of zones){
                ordereZones[z.name] = z.value;
            }
            return ordereZones;
        },
        formattedZoom () {
            return Number.parseInt(this.scale * 100);
        },

        overridenStyle (){
            if(this.page == null){
                return {};
            }
            let viewport = this.page.getViewport({ scale: 4, });
            return {
                position: 'absolute',
                width: viewport.width+'px',
                height: viewport.height+'px',
                color: 'rgba(0,0,0,0.4)'
            }
        },

        noPdfTemplate (){
            return !this.item.background_file;
        },
    },
    mounted () {
        if(this.noPdfTemplate) {
            this.render();
            return;
        }
        this.fetchPdf();
    },
    methods: {
        async fetchPdf (){
            let loadingTask = pdfjsLib.getDocument(this.item.background_file);
            loadingTask.promise.then((pdf) => {
                pdf.getPage(1).then((page) => {
                    this.$set(this, 'page', page);
                    this.render();
                });
            });
        },
        handleResize (){
            if(this.$refs.canvas){
                this.canvasWidth = this.$refs.canvas.clientWidth;
            }
            if(this.$refs.leftColumn){
                let h = this.$refs.clientWidth;
            }
        },
        render (){
            if(this.noPdfTemplate){
                let canvas = this.$refs.canvas;
                canvas.height = 595;
                canvas.width = 841;
                this.pageRendered = true;
                return;
            }
            let scale = 1;
            let viewport = this.page.getViewport({ scale: scale, });

            let canvas = this.$refs.canvas;
            let context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            let renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            let renderTask = this.page.render(renderContext)
            renderTask.promise.then(() => {
                this.pageRendered = true;

                this.$nextTick(() => {
                    this.handleResize();
                });
            });
        },
        updatePageDisplay (){
            this.item.display = !this.item.display;
            this.$eventBus.$emit('display-updated', {
                pageIndex: this.item.index,
                display: this.item.display,
            });
            if(!this.item.display){
                this.disableView();
            }else{
                this.pageRendered = false;
                // ici utilisation du settimeout car le $nexttick ne suffit pas pour l'affichage du loader
                setTimeout(() => {
                    this.render();
                }, 50);
            }
        },
        disableView (){
            let viewport = {};
            if(this.noPdfTemplate){
                viewport.height = 595;
                viewport.width = 841;
            }else{
                viewport = this.page.getViewport({ scale: 1, });
            }
            let canvas = this.$refs.canvas;
            var ctx = canvas.getContext("2d");

            var color1 = 'rgba(0,0,0,0.29)';

            var width = 32;
            var lineWidth = 10;
            var height = width;
            var x0 = width + lineWidth;
            var x1 = - lineWidth;
            var y0 = - lineWidth;
            var y1 = height + lineWidth;
            var offset = width;

            var p = document.createElement("canvas")
            p.width = width;
            p.height = height;
            var pctx = p.getContext('2d');

            pctx.strokeStyle = color1;
            pctx.lineWidth = lineWidth;
            pctx.beginPath();
            pctx.moveTo(x0, y0);
            pctx.lineTo(x1, y1);
            pctx.moveTo(x0 - offset, y0);
            pctx.lineTo(x1 - offset, y1);
            pctx.moveTo(x0 + offset, y0);
            pctx.lineTo(x1 + offset, y1);
            pctx.stroke();

            ctx.fillStyle = ctx.createPattern(p, 'repeat');
            ctx.fillRect(0, 0, viewport.width, viewport.height);

        },
        addPage (){
            this.$emit('add-page', this.item.index);
        },
    }
};
</script>

<style lang="scss">
.form-canvas-container{
    padding: 20px;
    border: 1px solid #000;
    margin-bottom: 20px;

    .pdf-column{
        display: flex;
        flex-direction: column;
    }
    .pdf-column:not(.limiter)>div{
        flex-basis: 0;
        flex-grow: 1;
        overflow-y: auto;
        overflow-x: none;
    }

    .no-fields{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        text-align: center;
        h1{
            color: #000;
        }
    }
    .page-not-loaded-yet{
        padding-top: 70.7%;
    }

    .canvas-overlay{
        z-index: 1;
        width: 841px;
        height: 595px;
        top: 0;
        left: 0;
        position: absolute;
        background-color: rgba(0,0,0,0.4);
    }

    .pdf-loading{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .pdfvuer {
        position: relative;
        width: 100%;
        height: 70.7%;
        canvas{
            border: 1px solid #cacaca;
        }
        .el-loading-text{
            color: #BDDE00;
        }
    }
    .pdf-container {
        max-height: 700px;
        overflow: hidden;
    }
    .button-container {
        position: absolute;
        top: 50%;
        left: 70%;
        z-index: 2;
    }
    .button-test {
        border-radius: 4px;
        border: 1px solid #CCC;
        padding: 20px;
    }

    .overlay-container {
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 2;
        max-width: 1000px;
        margin: auto;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .overlay-background{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-color: black;
        opacity: .3;
    }
    .overlay{
        opacity: 1;
        background-color: white;
        padding: 50px;
        z-index: 3;
    }
}
.page-action{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .el-button--text{
        color: #000 !important;
    }
    i{
        margin-right: 5px;
        font-size: 20px;
    }
}
.add-page{
    margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/report/pdfjs.vue